// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input:focus {
  outline: none !important;
  border: none !important;
}

.content-modal ::-webkit-scrollbar {
  width: 3px;
}

/* Track */
.content-modal ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.content-modal ::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.content-modal ::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.PhoneInputInternationalIconPhone {
  /* display: none !important; */
  margin-left: 6px;
}

.PhoneInputInternationalIconGlobe {
  display: none !important;
}

.PhoneInputCountry input {
  background-color: #F7F7F7 !important;
}

.PhoneInputInput {
  background-color: #F7F7F7 !important;
}

.contact-form .PhoneInputInput {
  background-color: white !important;
}


/* 
.broadcast video,
img {
  width: 100%;
  height: auto;
}

.broadcast video:-webkit-full-screen,
img:-webkit-full-screen {
  width: 100%;
  height: 100%;
}

.broadcast video:-moz-full-screen,
img:-moz-full-screen {
  width: 100%;
  height: 100%;
}

.broadcast video:-ms-fullscreen,
img:-ms-fullscreen {
  width: 100%;
  height: 100%;
}

.broadcast video:fullscreen,
img:fullscreen {
  width: 100%;
  height: 100%;
} */


.valition {
  background: black;
  padding: 10px;
  border-radius: 10px;
  vertical-align: middle;
  display: flex;
  color: #F7F7F7
}

.file-upload {
  cursor: pointer;
}
/* 
.file-upload:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  padding: 10px;
} */

.card {
  background: #e5e7ebb5;
  padding: 8px;
  border-radius: 10px;
}

.text-content-container {
  font-size: 8vmin !important;
  max-width: 80%;
  line-height: 1;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /* display: flex; */
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  overflow: hidden;
  padding: 10px;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: break-word;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
}

.fade-in {
  opacity: 1;
  /* Fully visible */
}

.fade-out {
  opacity: 0;
  /* Fully transparent */
}

.rdw-editor-toolbar{
  border-top: 0px !important;
  border :none !important;
  border-bottom :1px solid #e5e7eb !important;
  padding: 1rem !important;
}

[data-state="open"] {
  pointer-events: auto !important;
}

/* Radix UI Dialog Overlay fixes */
[data-state="open"] .radix-overlay {
  pointer-events: auto !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6BG;;;AAGH;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb;AACF;;AAEA;EACE,eAAe;AACjB;AACA;;;;GAIG;;AAEH;EACE,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,+BAA+B;AACjC","sourcesContent":["input:focus {\n  outline: none !important;\n  border: none !important;\n}\n\n.content-modal ::-webkit-scrollbar {\n  width: 3px;\n}\n\n/* Track */\n.content-modal ::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.content-modal ::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n/* Handle on hover */\n.content-modal ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.PhoneInputInternationalIconPhone {\n  /* display: none !important; */\n  margin-left: 6px;\n}\n\n.PhoneInputInternationalIconGlobe {\n  display: none !important;\n}\n\n.PhoneInputCountry input {\n  background-color: #F7F7F7 !important;\n}\n\n.PhoneInputInput {\n  background-color: #F7F7F7 !important;\n}\n\n.contact-form .PhoneInputInput {\n  background-color: white !important;\n}\n\n\n/* \n.broadcast video,\nimg {\n  width: 100%;\n  height: auto;\n}\n\n.broadcast video:-webkit-full-screen,\nimg:-webkit-full-screen {\n  width: 100%;\n  height: 100%;\n}\n\n.broadcast video:-moz-full-screen,\nimg:-moz-full-screen {\n  width: 100%;\n  height: 100%;\n}\n\n.broadcast video:-ms-fullscreen,\nimg:-ms-fullscreen {\n  width: 100%;\n  height: 100%;\n}\n\n.broadcast video:fullscreen,\nimg:fullscreen {\n  width: 100%;\n  height: 100%;\n} */\n\n\n.valition {\n  background: black;\n  padding: 10px;\n  border-radius: 10px;\n  vertical-align: middle;\n  display: flex;\n  color: #F7F7F7\n}\n\n.file-upload {\n  cursor: pointer;\n}\n/* \n.file-upload:hover {\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  padding: 10px;\n} */\n\n.card {\n  background: #e5e7ebb5;\n  padding: 8px;\n  border-radius: 10px;\n}\n\n.text-content-container {\n  font-size: 8vmin !important;\n  max-width: 80%;\n  line-height: 1;\n  color: #fff;\n  text-align: center;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  /* display: flex; */\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  overflow: hidden;\n  padding: 10px;\n  box-sizing: border-box;\n  white-space: normal;\n  word-wrap: break-word;\n  opacity: 1;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.fade-in {\n  opacity: 1;\n  /* Fully visible */\n}\n\n.fade-out {\n  opacity: 0;\n  /* Fully transparent */\n}\n\n.rdw-editor-toolbar{\n  border-top: 0px !important;\n  border :none !important;\n  border-bottom :1px solid #e5e7eb !important;\n  padding: 1rem !important;\n}\n\n[data-state=\"open\"] {\n  pointer-events: auto !important;\n}\n\n/* Radix UI Dialog Overlay fixes */\n[data-state=\"open\"] .radix-overlay {\n  pointer-events: auto !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
